import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20 } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path d="M8 7H20" stroke="#8B98A6" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M4 7H4.00898" stroke="#8B98A6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 12H4.00898" stroke="#8B98A6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 17H4.00898" stroke="#8B98A6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 12H20" stroke="#8B98A6" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8 17H20" stroke="#8B98A6" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export default SvgComponent
